import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu, isActiveExpandImageModal } from 'modules/actions/statusMenu';
import './style.scss';
const ExpandImage = () => {
  const dispatch = useDispatch();
  const url = useSelector(state => state.isActive.expandImageUrl);

  const handleOnError = event => {
    event.currentTarget.src = 'images/noimage.png';
    event.currentTarget.className = 'errorImg';
    event.currentTarget.alt = '이미지 로드 실패';
  };
  const disablePopup = () => {
    dispatch(disableAllMenu());
  };

  const [imageStyle, setImageStyle] = useState({});

  // useLayoutEffect(() => {
  //   if (window.innerHeight < window.innerWidth) {
  //     setImageStyle({
  //       height: 'calc(100% - 150px)',
  //       maxWidth: '100%',
  //     });
  //   } else {
  //     setImageStyle({
  //       width: '100%',
  //     });
  //   }
  //   function handleResize(a) {
  //     if (window.innerHeight < window.innerWidth) {
  //       setImageStyle({
  //         height: 'calc(100% - 150px)',
  //         maxWidth: '100%',
  //       });
  //     } else {
  //       setImageStyle({
  //         width: '100%',
  //       });
  //     }
  //   }
  //   // console.log(visibleSlides);
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  useLayoutEffect(() => {
    const img = new Image();
    img.src = url;
    const newWindow = window.open('', '_blank', `width=${img.width},height=${img.height}`, '_blank');
    newWindow.document.write(`<img src=${url} />`);
    newWindow.document.close();
    // const onScroll = () => {
    //   const height = newWindow.document.body.scrollHeight;
    //   const top = newWindow.scrollY || newWindow.document.documentElement.scrollTop;
    //   const bottom = top + newWindow.innerHeight;

    //   if (bottom >= height) {
    //     newWindow.document.body.scrollTop = 0;
    //     newWindow.scrollBy(0, -1);
    //   } else if (top <= 0) {
    //     newWindow.document.body.scrollTop = height;
    //     newWindow.scrollBy(0, 1);
    //   }
    // };

    // newWindow.addEventListener('scroll', onScroll);

    // newWindow.onbeforeunload = () => {
    //   newWindow.removeEventListener('scroll', onScroll);
    // };
    dispatch(disableAllMenu());
  },[]);

  // return (
  //   <div className="popup_image_main" onClick={disablePopup}>
  //     <img src={url} alt="" onError={handleOnError} style={imageStyle} />
  //   </div>
  // );
  return '';
};

export default ExpandImage;
